<mat-toolbar>
  <mat-icon *ngIf="canNavigateUp" class="pointer" (click)="navigateUp()">arrow_back</mat-icon>
  <span style="margin-left: 8px">{{path || '/'}}</span>
</mat-toolbar>

<div style="visibility: hidden; position: fixed"
[style.left]="contextMenuPosition.x"
[style.top]="contextMenuPosition.y"
[matMenuTriggerFor]="contextMenu">
</div>

<mat-card class="mat-elevation-z0 card-padding">
  <table mat-table [dataSource]="dataSource" matSort matSortActive="name"matSortDirection="asc">

    <ng-container matColumnDef="isFolder">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let element" (contextmenu)="openMenu($event, element)">
        <mat-icon color="primary" (click)="navigate(element)" class="file-or-folder-icon pointer" *ngIf="element.isFolder">folder</mat-icon>
        <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="!element.isFolder">insert_drive_file</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element" (contextmenu)="openMenu($event, element)">
        <span *ngIf="!element.content" (click)="navigate(element)">{{ element.name }}</span>
        <span *ngIf="element.content" (click)="openFileContentDialog(element)">{{ element.name }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModifiedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last modified date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.lastModifiedDate | date: "medium":"+0200":"de" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Size</th>
      <td mat-cell *matCellDef="let element">
        {{ formatSize(element.size) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-card>

<mat-menu #contextMenu="matMenu" >
  <ng-template matMenuContent let-element="element">
    <button mat-menu-item (click)="openDeleteDialog(element)">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>

    <button *ngIf="element.content" mat-menu-item (click)="openFileContentDialog(element)">
      <mat-icon>insert_drive_file</mat-icon>
      <span>Show</span>
    </button>
  </ng-template>
</mat-menu>
